const styles = {
  searchClearButton: "room-issue-node__search-clear-button",
  searchField: "room-issue-node__search-field",
  searchInput: "room-issue-node__search-input"
};

export default styles;
